module.exports = __webpack_public_path__ + "static/img/btn_blog.eda61f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/etc/btn_blog.jpg
// module id = sTRz
// module chunks = 1